import React from "react";
import { X, CheckCircle, XCircle, Clock, MessageCircle, HelpCircle } from "lucide-react";

const JobApprovalDialog = ({ onClose, status = "waiting", finalPrice, paymentReceived }) => {

  const statusConfig = {
    waiting: {
      icon: Clock,
      iconColor: "text-yellow-500",
      bgColor: "bg-yellow-50 dark:bg-yellow-900/20",
      borderColor: "border-yellow-200 dark:border-yellow-800",
      title: "Waiting for Approval",
      message: "Your completed work is pending approval from the customer. We'll notify you once they review it.",
      showContactSupport: true,
    },
    approved: {
      icon: CheckCircle,
      iconColor: "text-green-500",
      bgColor: "bg-green-50 dark:bg-green-900/20",
      borderColor: "border-green-200 dark:border-green-800",
      title: "Task Successfully Completed!",
      message: "Great news! Your work has been approved by the customer.",
      showContactSupport: false,
    },
    notApproved: {
      icon: XCircle,
      iconColor: "text-red-500",
      bgColor: "bg-red-50 dark:bg-red-900/20",
      borderColor: "border-red-200 dark:border-red-800",
      title: "Task Not Approved",
      message: "Unfortunately, your work was not approved by the customer. The work may not have been completed as expected or did not meet the customer's requirements. Please contact support if you believe this is an error or need assistance.",
      showContactSupport: true,
    },
  };

  const config = statusConfig[status] || statusConfig.waiting;
  const Icon = config.icon;

  const formattedPrice =
    finalPrice != null && !Number.isNaN(Number(finalPrice))
      ? `PKR ${Number(finalPrice).toLocaleString()}`
      : null;

  const approvedMessage =
    paymentReceived
      ? `Payment received${formattedPrice ? `: ${formattedPrice}` : ""}. You can now rate the customer.`
      : `Final price${formattedPrice ? `: ${formattedPrice}` : ""}. Please collect payment from the customer.`;

  const handleContactSupport = () => {
    // TODO: Implement contact support functionality
    alert("Contact support feature will be implemented soon.");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-sm mx-4">
        {/* Header */}
        <div className="px-4 py-3 border-b border-gray-200 dark:border-slate-700 flex items-center justify-between">
          <h2 className="text-base font-bold text-gray-900 dark:text-white">
            Job Status
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors"
          >
            <X className="h-5 w-5 text-gray-600 dark:text-gray-300" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          <div className={`${config.bgColor} ${config.borderColor} border-2 rounded-lg p-4 text-center mb-3 max-h-[240px] overflow-auto`}>
            <Icon className={`h-10 w-10 mx-auto mb-3 ${config.iconColor}`} />
            <h3 className="text-base font-bold text-gray-900 dark:text-white mb-1">
              {config.title}
            </h3>
            <p className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
              {status === "approved" ? (
                <>
                  {config.message}
                  <span className="block mt-2">{approvedMessage}</span>
                </>
              ) : (
                config.message
              )}
            </p>
          </div>

          {config.showContactSupport && (
            <button
              onClick={handleContactSupport}
              className="w-full px-4 py-3 rounded-lg border-2 border-[#EFA938] text-[#EFA938] font-semibold hover:bg-[#FFF8EF] dark:hover:bg-orange-900/20 transition-colors flex items-center justify-center gap-2"
            >
              <MessageCircle className="h-5 w-5" />
              Contact Support
            </button>
          )}
        </div>

        {/* Footer */}
        <div className="px-4 py-3 border-t border-gray-200 dark:border-slate-700 flex items-center justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-200 dark:hover:bg-slate-600 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobApprovalDialog;

